import React, { useEffect, useRef } from "react";
import anime from "animejs";
import { useParams } from "react-router-dom";
import executivesData from "../../data/seniorexecutiveteamdata";

const ExecutivePage = () => {
  const { executiveId } = useParams();
  const executive = executivesData.find(
    (exec) => exec.id === parseInt(executiveId)
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", 
    });
  }, []);
  const textRef = useRef(null);
  const wavePathRef = useRef(null);
  useEffect(() => {
    if (!executive) return;

    const textElement = textRef.current;
    const text = textElement?.textContent;
    if (text) {
      textElement.innerHTML = text
        .split("")
        .map((char) => `<span class="letter">${char}</span>`)
        .join("");

      anime.timeline({ loop: false }).add({
        targets: ".letter",
        opacity: [0, 1],
        translateY: [20, 0],
        easing: "easeOutExpo",
        duration: 1000,
        delay: (el, i) => i * 50,
      });
    }
  }, [executive]);

  useEffect(() => {
    if (!executive) return;

    anime({
      targets: wavePathRef.current,
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "easeInOutSine",
      duration: 2000,
      loop: false,
    });
  }, [executive]);

  if (!executive) {
    return <h2>Executive not found</h2>;
  }

  return (
    <div>

      <div className="relative">
        <div className="relative text-center py-20 bg-sddarkgray">
          <svg
            className="absolute top-1/2 transform -translate-y-1/2 left-0 w-full z-0"
            viewBox="0 0 1000 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              ref={wavePathRef}
              d="M0 50 Q 50 10, 100 50 T 200 30 T 300 10 T 400 50 T 500 20 T 600 50 T 700 50 T 800 50 T 900 60 T 1000 0"
              stroke="#ffa600"
              strokeWidth="2"
              fill="none"
              strokeDasharray="2000"
            />
          </svg>
          <div className="relative z-10 space-y-5">
            <div className="bg-sdbodywhite p-2 inline-block rounded-md">
              <p className="text-xl font-semibold text-black ">
                Senior Executive Team
              </p>
            </div>
            <div>
              <div className="bg-sddarkgray inline-block px-">
                <h1 className="text-4xl font-bold mt-2">
                  <span
                    ref={textRef}
                    style={{
                      color: "#ffa600", // Fill color
                      textShadow: "0 0 10px rgba(200, 176, 79, 0.715)", // Centered blur shadow
                    }}
                  >
                    {executive.name}
                  </span>
                </h1>
              </div>
            </div>
            <div className="border-2 border-white inline-block p-2 rounded-md">
              <p className="text-lg text-[#ffa600] mt-1">
                {executive.position}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div>
            <div className="bg-sdorange bg-opacity-15 py-16 space-y-5">
              <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-sdorange mx-auto">
                <img
                  src={executive.image}
                  alt={executive.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="max-w-2xl mx-auto text-center">
                <p className="text-lg text-gray-700 leading-relaxed font-bold">
                  {executive.aboutPosition}
                </p>
              </div>
            </div>

            <div className="p-3 md:flex md:justify-center gap-4 md:py-14 ">
              <div className="flex md:flex-col items-center ">
                <div className="border-2 border-sdorange rounded-lg p-2 flex md:flex-col gap-3">
                  <div>
                    <img
                      src="/Image Assets/footer-icons/facebook-svgrepo-com.svg"
                      alt="Facebook"
                      className="w-8 h-8 cursor-pointer hover:scale-110 transition-transform"
                    />
                  </div>
                  <div>
                    <img
                      src="/Image Assets/footer-icons/linkedin-svgrepo-com.svg"
                      alt="LinkedIn"
                      className="w-8 h-8 cursor-pointer hover:scale-110 transition-transform"
                    />
                  </div>
                  <div>
                    <img
                      src="/Image Assets/footer-icons/twitter-svgrepo-com.svg"
                      alt="Twitter"
                      className="w-8 h-8 cursor-pointer hover:scale-110 transition-transform"
                    />
                  </div>
                </div>
              </div>
              <div className="max-w-2xl text-justify flex-1">
                {executive.aboutExecutive.split("\n").map((line, index) => (
                  <p
                    key={index}
                    className="text-base text-gray-600 leading-relaxed mb-4"
                  >
                    {line}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutivePage;
